import { render } from "./EditService.vue?vue&type=template&id=624bd550&ts=true"
import script from "./EditService.vue?vue&type=script&lang=ts"
export * from "./EditService.vue?vue&type=script&lang=ts"

import "./EditService.vue?vue&type=style&index=0&id=624bd550&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/api2-production/workspace/api2/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__